.filters {
  --filter-border: var(--bs-border-color, #dee2e6);
  width: 100%;
  color: var(--bs-body-color, #212529);
  font-size: 0.8125rem;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--filter-border);
}

.heading {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
}

.clearButton {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--bs-link-color, #0d6efd);
  font: inherit;
}

.clearButton:disabled {
  color: var(--bs-secondary-color, #6c757d);
  cursor: default;
  opacity: 0.65;
}

.section {
  border-bottom: 1px solid var(--filter-border);
}

.summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.55rem 0;
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: 600;
  list-style: none;
}

.summary::-webkit-details-marker {
  display: none;
}

.summary::after {
  content: '+';
  color: var(--bs-secondary-color, #6c757d);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1;
}

.section[open] > .summary::after {
  content: '−';
}

.options {
  display: grid;
  gap: 0.3rem;
  padding: 0 0 0.6rem;
}

.check {
  min-height: 1.15rem;
  margin: 0;
}

.check :global(.form-check-input) {
  width: 0.875rem;
  height: 0.875rem;
  margin-top: 0.16rem;
}

.check :global(.form-check-label) {
  padding-left: 0.1rem;
  line-height: 1.25;
}

.dateGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.4rem;
  padding-bottom: 0.5rem;
}

.dateField label {
  display: block;
  margin-bottom: 0.2rem;
  color: var(--bs-secondary-color, #6c757d);
  font-size: 0.75rem;
}

.dateField input {
  min-height: 1.9rem;
  padding: 0.25rem 0.4rem;
  font-size: 0.75rem;
}

.showFiltersButton {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 2.75rem;
}

.filterDrawer {
  --bs-offcanvas-width: min(22rem, 100vw);
}

.filterDrawerBody {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.doneButton {
  width: 100%;
}

@media (min-width: 992px) {
  .showFiltersButton,
  .doneButton {
    display: none;
  }

  .filterDrawerBody {
    padding: 0;
    overflow: visible;
  }
}
